<template>
  <nav class="page-navigation">
    <NavigationItems />
  </nav>
</template>
<script>
import NavigationItems from "./NavigationItems";

export default {
  components: { NavigationItems },
  methods: {
    setScrollSettings(el) {
      return {
        el: "#" + el
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";

.page-navigation {
  display: none;
  justify-content: center;
  margin-top: 1.5rem;
  margin-bottom: 0.1rem;
}
@media (min-width: $min-width-extended) {
  .page-navigation {
    display: flex;
  }
}
</style>
